"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MegaMenu = function MegaMenu(props) {
  return _react2.default.createElement(
    "svg",
    Object.assign({ width: "1em", height: "1em" }, props),
    _react2.default.createElement("path", { d: "M1015.018 961.322L757.521 703.825c-4.591-4.591-10.579-6.986-16.967-6.986h-20.56c68.466-74.055 110.384-172.862 110.384-281.65C830.378 185.837 644.541 0 415.189 0S0 185.837 0 415.189c0 229.352 185.837 415.189 415.189 415.189 108.788 0 207.595-41.918 281.65-110.185v20.36c0 6.388 2.595 12.376 6.986 16.967l257.497 257.497c9.382 9.382 24.552 9.382 33.934 0l19.761-19.761c9.382-9.382 9.382-24.552 0-33.934zM415.189 766.503c-194.221 0-351.314-157.093-351.314-351.314S220.968 63.875 415.189 63.875c194.221 0 351.314 157.093 351.314 351.314S609.41 766.503 415.189 766.503zM1807.074 81.31H835.506c-7.384 0-13.37-6.067-13.37-13.552V13.551c0-7.484 5.986-13.552 13.37-13.552h971.568c7.384 0 13.37 6.067 13.37 13.552v54.207c0 7.484-5.986 13.552-13.37 13.552zm2.507 361.379h-789.399c-6 0-10.863-6.067-10.863-13.552V374.93c0-7.484 4.864-13.552 10.863-13.552h789.399c6 0 10.863 6.067 10.863 13.552v54.207c0 7.484-4.864 13.552-10.863 13.552zm2.507 361.378h-607.23c-4.615 0-8.356-6.067-8.356-13.552v-54.207c0-7.484 3.741-13.552 8.356-13.552h607.23c4.615 0 8.356 6.067 8.356 13.552v54.207c0 7.484-3.741 13.552-8.356 13.552z" })
  );
};

exports.default = MegaMenu;